/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require("./bootstrap");

window.Vue = require("vue");

import VeeValidate, { Validator } from "vee-validate";
import es from "vee-validate/dist/locale/es";
import vSelect from "vue-select";
import VModal from "vue-js-modal";
import VuePrism from "vue-prism";
import Tabs from "vue-tabs-component";
import vueSmoothScroll from "vue-smooth-scroll";
import VueGoodTable from "vue-good-table";
import VueAutosize from "vue-autosize";
import { Money } from "v-money";
import VueTheMask from "vue-the-mask";
import Cleave from "vue-cleave-component";
import Loader from "./components/element/Loader.vue";
import Vue from "vue";
import Chartkick from "vue-chartkick";
import Chart from "chart.js";
 
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";

import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { Icon } from "leaflet";
import "leaflet/dist/leaflet.css";


delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

Vue.component("l-map", LMap);
Vue.component("l-tile-layer", LTileLayer);
Vue.component("l-marker", LMarker);
Vue.component("VueCtkDateTimePicker", VueCtkDateTimePicker);

//Doctores

Validator.localize("es", es);

/// Init
Vue.use(VeeValidate);
Vue.use(VModal);
Vue.use(VuePrism);
Vue.use(Tabs);
Vue.use(VueGoodTable);
Vue.use(Cleave);
Vue.use(VueTheMask);
Vue.use(vueSmoothScroll);
Vue.use(VueAutosize);
Vue.use(Chartkick.use(Chart));
/// Componentes
Vue.component("v-select", vSelect);
Vue.component("ButtonCard", require("./components/element/ButtonCard.vue"));
Vue.component("money", Money);
Vue.component("input-field", require("./components/element/InputField.vue"));
Vue.component("fileUpload", require("./components/element/FileUpload.vue"));
Vue.component(
  "notificaciones",
  require("./components/element/Notificaciones.vue")
);
Vue.component(
  "textarea-field",
  require("./components/element/TextareaField.vue")
);
Vue.component("dropdown", require("./components/element/Dropdown.vue"));
Vue.component(
  "dropdown-notification",
  require("./components/element/DropdownNotification.vue")
);
Vue.component("notification", require("./components/element/Notification.vue"));
Vue.component("loader", Loader);
Vue.component("kTable", require("./components/element/KTable.vue"));
Vue.component("datePicker", require("./components/element/DatePicker.vue"));
Vue.component("datePicker2", require("./components/element/DatePicker2.vue"));
Vue.component("datePicker3", require("./components/element/DatePicker3.vue"));
Vue.component(
  "checkedListbox",
  require("./components/element/CheckedListbox.vue")
);
Vue.component(
  "TooltipSelect",
  require("./components/element/TooltipSelect.vue")
);

/// Layout
Vue.component("kp-header", require("./components/layout/Header.vue"));
Vue.component("kp-logo", require("./components/layout/Logo.vue"));
Vue.component("kp-menu", require("./components/layout/menu/MainMenu.vue"));
Vue.component("kp-submenu", require("./components/layout/menu/Submenu.vue"));
Vue.component("kp-support", require("./components/layout/Support.vue"));
Vue.component("menu-search", require("./components/layout/menu/Search.vue"));
Vue.component("kp-user", require("./components/layout/UserStatus.vue"));

//Doctores
Vue.component(
  "consultaDoctores",
  require("./components/forms/doctores/ConsultaDoctores.vue")
);
Vue.component("kDoctor", require("./components/forms/doctores/Doctor.vue"));
Vue.component("registroDoctor", require("./components/forms/doctores/RegistroDoctor.vue"));

//CIE10
Vue.component(
  "consultaCie10",
  require("./components/forms/cie10/ConsultaCie10.vue")
);
Vue.component("kCie10", require("./components/forms/cie10/Cie10.vue"));

//Consultas
Vue.component(
  "historicoConsultas",
  require("./components/forms/consultas/HistoricoConsultas.vue")
);
Vue.component(
  "galeriaMedios",
  require("./components/forms/consultas/GaleriaMedios.vue")
);

//Procesos
Vue.component(
  "consultaCierrePagos",
  require("./components/forms/procesos/ConsultaCierrePagos.vue")
);
Vue.component(
  "cierrePago",
  require("./components/forms/procesos/CierrePago.vue")
);
Vue.component(
  "itemCierrePago",
  require("./components/forms/procesos/ItemCierrePago.vue")
);
Vue.component(
  "doctoresCierrePago",
  require("./components/forms/procesos/DoctoresCierrePago.vue")
);

//Pacientes
Vue.component(
  "consultaPacientes",
  require("./components/forms/pacientes/ConsultaPacientes.vue")
);
Vue.component("kPaciente", require("./components/forms/pacientes/Paciente.vue"));

Vue.component(
  "multipleFotos",
  require("./components/element/MultipleFotos.vue")
);
Vue.component("trFoto", require("./components/element/TrFoto.vue"));

//Dashboard
Vue.component("KDashboard", require("./components/KDashboard.vue"));

/// Mixins
Vue.mixin({
  methods: {
    route: route
  }
});

axios.interceptors.request.use(
  function(config) {
    let id = uuid();
    let Modal = Vue.extend(Loader);
    let ModalComponent = new Modal({
      propsData: {
        name: id,
        loading: true
      }
    }).$mount();
    app.$refs.app.appendChild(ModalComponent.$el);
    config.component = ModalComponent;
    config.id = id;
    app.$modal.show(id);
    return config;
  },
  function(error) {
    app.$modal.hide(error.config.id);
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function(response) {
    app.$modal.hide(response.config.id);
    return response;
  },
  function(error) {
    app.$modal.hide(error.config.id);
    return Promise.reject(error);
  }
);

const app = new Vue({
  el: "#app"
});



// WEBPACK FOOTER //
// ./resources/assets/js/app.js